import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import { Separator } from "../components/ui/separator";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_cardoso-bouw/artifacts/jj2smc9a_JPEG-afbeelding-4738-BFE8-D0-0.jpeg";

const services = [
  { name: "Aannemer", path: "/aannemer" },
  { name: "Badkamer Renovatie", path: "/badkamer-renovatie" },
  { name: "Stukadoor", path: "/stukadoor" },
  { name: "Schilderwerk", path: "/schilderwerk" },
  { name: "Timmerwerk", path: "/timmerwerk" },
  { name: "Complete Renovatie", path: "/complete-renovatie" },
  { name: "Werk op uurtarief", path: "/uurtarief" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#005F5F] text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div className="space-y-6">
            <div className="bg-white rounded-full p-2.5 shadow-sm overflow-hidden inline-flex items-center justify-center" style={{width: '64px', height: '64px'}}>
              <img
                src={LOGO_URL}
                alt="Cardoso Bouw en Onderhoud - Aannemer Breukelen"
                className="h-11 w-11 object-contain"
              />
            </div>
            <p className="text-white/70 text-sm leading-relaxed max-w-xs">
              Professioneel bouwbedrijf uit Breukelen met meer dan 8 jaar ervaring in renovaties en onderhoud. Werkzaam in Noord-Holland, Zuid-Holland, Utrecht en Flevoland.
            </p>
            <a
              href="https://www.instagram.com/cardosobouwenonderhoud"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 text-[#C5A059] hover:text-white transition-colors text-sm"
            >
              <Instagram className="w-5 h-5" />
              @cardosobouwenonderhoud
            </a>
          </div>

          <div>
            <h4 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-wider mb-6 text-[#C5A059]">
              Diensten
            </h4>
            <ul className="space-y-3">
              {services.map((service) => (
                <li key={service.path}>
                  <Link
                    to={service.path}
                    data-testid={`footer-link-${service.path.replace("/", "")}`}
                    className="text-white/70 hover:text-[#C5A059] transition-colors text-sm"
                  >
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-wider mb-6 text-[#C5A059]">
              Contact
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-1 text-[#C5A059] flex-shrink-0" />
                <span className="text-white/70 text-sm">
                  Merwedeweg 5C1<br />
                  3621LP Breukelen<br />
                  Nederland
                </span>
              </li>
              <li>
                <a
                  href="tel:+31685071009"
                  data-testid="footer-phone"
                  className="flex items-center gap-3 text-white/70 hover:text-[#C5A059] transition-colors text-sm"
                >
                  <Phone className="w-4 h-4 text-[#C5A059] flex-shrink-0" />
                  06 85 07 10 09
                </a>
              </li>
              <li>
                <a
                  href="mailto:info@cardosobouw.nl"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-white/70 hover:text-[#C5A059] transition-colors text-sm"
                >
                  <Mail className="w-4 h-4 text-[#C5A059] flex-shrink-0" />
                  info@cardosobouw.nl
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-['Barlow_Condensed'] text-lg font-bold uppercase tracking-wider mb-6 text-[#C5A059]">
              Bedrijfsgegevens
            </h4>
            <ul className="space-y-3 text-sm text-white/70">
              <li><span className="text-white/50">KVK:</span> 85310646</li>
              <li><span className="text-white/50">BTW:</span> NL004077138B58</li>
              <li><span className="text-white/50">IBAN:</span> NL33INGB0709828160</li>
              <li><span className="text-white/50">BIC:</span> INGBNL2A</li>
            </ul>
          </div>
        </div>

        <Separator className="my-10 bg-white/10" />

        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/40 text-xs">
            &copy; {new Date().getFullYear()} Cardoso Bouw en Onderhoud. Alle rechten voorbehouden.
          </p>
          <div className="flex gap-6">
            <Link to="/contact" data-testid="footer-bottom-contact" className="text-white/40 hover:text-[#C5A059] transition-colors text-xs">
              Contact
            </Link>
            <Link to="/privacy" data-testid="footer-privacy-link" className="text-white/40 hover:text-[#C5A059] transition-colors text-xs">
              Privacybeleid
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
